import { createRoot } from "react-dom/client";
import { SideNavUI } from "./UI";

const SideNav = (options = {}) => {
  const {
    config,
    isAltStyle,
    isExpanded,
    items,
    onCollapsed,
    onExpanded,
    rootElement,
  } = options;

  const root = createRoot(rootElement);
  return root.render(
    <SideNavUI
      onExpanded={onExpanded}
      onCollapsed={onCollapsed}
      isExpanded={isExpanded}
      config={config}
      items={items}
      isAltStyle={isAltStyle}
    />,
  );
};

export default SideNav;
